// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6446) return "static/chunks/53c13509-e43d78a5772aaf9d.js";
	if (chunkId === 2544) return "static/chunks/2544-2ca9d9bc0c21a72e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2996":"4ff6b50b8799bc16","3172":"366bf01c5c3e880e","4360":"48e04e886f702bad","5684":"83ccb4a59a13869a","6493":"b1af86cc6841f570","6613":"cf5c2dfac109c922","6980":"1f91fbd1ed6f4525","7217":"476667cc34a104f5","8346":"55b9fb6e9cc6a660","8593":"9655775f0dab9ebe","9911":"83ada93ea4af3e6b"}[chunkId] + ".js";
};